import {
  EventTypes,
  segment,
  track,
  trackGoldStandardEvent,
} from '@mc/track-event'
import {
  ActionTypes,
  KeyTypes,
  saveUserData,
  getTrackedId,
} from '@mc/user-data'
import { setMetaProductIdCookie } from 'libs/cookies/metaProductIdCookie'

export const trackCampPageViewed = ({
  id,
  slug,
  title,
  primaryCategoryId,
  categoryIds,
  subcategoryIds,
  price,
  currency,
}: {
  id: string
  slug: string
  title: string
  primaryCategoryId: number
  categoryIds: number[]
  subcategoryIds: number[]
  price: number | undefined
  currency: string
}) => {
  const campId = getTrackedId({ key: KeyTypes.CAMP, id })
  const primaryCatId = getTrackedId({
    key: KeyTypes.CATEGORY,
    id: primaryCategoryId,
  })
  const mappedCategoryIds = categoryIds.map((categoryId) =>
    getTrackedId({ key: KeyTypes.CATEGORY, id: categoryId }),
  )
  const mappedSubCategoryIds = subcategoryIds.map((subcategoryId) =>
    getTrackedId({ key: KeyTypes.SUBCATEGORY, id: subcategoryId }),
  )

  trackGoldStandardEvent(EventTypes.PRODUCT_VIEWED_GOLD_STANDARD, {
    content_type: 'product',
    product_id: campId,
    class: slug,
    name: title,
    price,
    quantity: 1,
    category: primaryCatId,
    category_ids: mappedCategoryIds,
    subcategory_ids: mappedSubCategoryIds,
    stored_category_id: primaryCatId,
    currency,
  })

  saveUserData({
    key: KeyTypes.CATEGORY,
    id: primaryCatId,
    actionType: ActionTypes.BROWSING,
    eventName: EventTypes.PRODUCT_VIEWED_GOLD_STANDARD,
  })

  setMetaProductIdCookie(campId)
}

export const trackCampOverviewTrailerCTAClick = ({
  slug,
  isLive,
  contentId,
}: {
  slug: string
  isLive: boolean
  contentId: string
}) => {
  track(segment.EventTypes.COURSE_MARKETING_CLICK, {
    category: 'body',
    location: 'body',
    action: 'Watch Trailer',
    page_type: 'class-page',
    class_type: 'camp',
    content_type: 'Camp Trailer',
    content_id: contentId,
    class: slug,
    instructor_coming_soon: !isLive,
  })
}

export const trackCampFooterTrailerCTAClick = ({
  slug,
  isLive,
  contentId,
}: {
  slug: string
  isLive: boolean
  contentId: string
}) => {
  track(segment.EventTypes.EXPLAINER_PAGE_CLICK, {
    category: 'video-player',
    location: 'video-player',
    action: 'Watch Trailer',
    page_type: 'class-page',
    class_type: 'camp',
    content_type: 'Camp Trailer',
    content_id: contentId,
    class: slug,
    instructor_coming_soon: !isLive,
  })
}

const getCampFooterVideoEventAttributes = (
  slug: string,
  isLive: boolean,
  contentId: string,
) => ({
  category: 'footer-cta',
  location: 'footer-cta',
  page_type: 'class-page',
  class_type: 'camp',
  content_type: 'Camp Trailer',
  content_id: contentId,
  class: slug,
  instructor_coming_soon: !isLive,
})

const getCampOverviewVideoEventAttributes = (
  slug: string,
  isLive: boolean,
  contentId: string,
) => ({
  category: 'body',
  location: 'body',
  page_type: 'class-page',
  class_type: 'camp',
  content_type: 'Camp Trailer',
  content_id: contentId,
  class: slug,
  instructor_coming_soon: !isLive,
})

export const getVideoExtraTrackingInfo = (
  isOverview: boolean,
  {
    slug,
    isLive,
    contentId,
  }: { slug: string; isLive: boolean; contentId: string },
) => {
  if (isOverview) {
    return getCampOverviewVideoEventAttributes(slug, isLive, contentId)
  }

  return getCampFooterVideoEventAttributes(slug, isLive, contentId)
}
